/**
 * Point React.Ref instance value at element
 */
export function setRef(ref, element) {
  if (typeof ref === 'function') {
    ref(element);
  } else if (ref) {
    ref.current = element;
  }
}
//# sourceMappingURL=ref-util.js.map